module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABEklEQVR4AWOgC+D2apZud5XpciKIYDoU17KZT5es88elznWqQ/Z8exQNQMSktUQ0Pw5TtdEER7/pDrs228gia4AipTX8UcUOkx0v77L+f9Ty/A5rx8mOQHUTVth+PGhlP9kRoQEZHVzpcXGn9eN9Vi5THFatt4HYc3239bw1tigaZi67x6gEYhzbZm03yVGm08l3msPnQ1aRsxwy59mbT3RE9wOLyjogaRaw79xSf6B7gGYvXGMLdBuWUKrqvsKkDFLNrLIupeKspvUsoJ6X+632LvYzSSmQ6XRG16BkvwOoGqgnKOM4kIGG2G0nSjV6o2iASIA9gB0x6y4QK4lA1zBr+X2IN7AiRpVVgok5DIMSAABtR6BwbAqaBgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/CX.png
// module id = 1119
// module chunks = 0